import type { SlideGrid } from '../SwiperSlider';

export const desktopImages = [
  'game-card-desk-1',
  'game-card-desk-2',
  'game-card-desk-3',
  'game-card-desk-4',
];

export const mobileImages = [
  'game-card-mob-1',
  'game-card-mob-2',
  'game-card-mob-3',
];

export const imgsWithLocale: Record<string, string[]> = {
  au: [
    'redgenn/15DragonPearlsHoldandWin',
    'gamebeat/RagingLion',
    'voltent/HotSlot777Crown',
    'playson/CoinStrike2HoldandWin',
    'platipus/tripledragon',
    'redgenn/3CoinVolcanoes',
    '3oaks/gold_express',
    'softswiss/GoldRushWithJohnny',
  ],
  ca: [
    'pragmaticexternal/SugarRush1000',
    'pragmaticexternal/BigBassBonanza',
    'gamebeat/BuffaloTrail',
    'pragmaticexternal/GatesofOlympusSuperScatter',
    'mascot/the_biggest_win_x50',
    'softswiss/GoldRushWithJohnny',
    'gamebeat/RagingLion',
    '1spin4win/HoldTheGoldHoldAndWin',
  ],
  de: [
    'pragmaticexternal/GatesofOlympusSuperScatter',
    'pragmaticexternal/BigBassSplash',
    'n2games/BookOfRaMagic',
    'pragmaticexternal/BookofFallen',
    'pragmaticexternal/SugarRush1000',
    'endorphina/endorphina2_HellHot100',
    'playngo/BookofDead',
    'oryx/GAMRamsesBook',
  ],
  nz: [
    'pragmaticexternal/GatesofOlympusSuperScatter',
    '3oaks/black_wolf_2',
    'quickfire/MGS_WackyPanda',
    'mascot/the_biggest_win_x50',
    'gamebeat/BookOfAncients',
    'softswiss/ElvisFroginVegas',
    'pragmaticexternal/BigBassSplash',
    'voltent/HotSlot777Crown',
  ],
  default: [
    'platipus/tripledragon',
    'voltent/HotSlot777Crown',
    'gamebeat/BuffaloTrail',
    'playngo/BookofDead',
    'pragmaticexternal/BigBassBonanza',
    'softswiss/GoldRushWithJohnny',
    'mascot/the_biggest_win_x50',
    'onlyplay/WolfTreasure',
  ],
};

export const IMG_DESKTOP_SIZE = 132;
export const IMG_MOBILE_SIZE = 104;

export const DESKTOP_GAMES_COUNT = 4;
export const MOBILE_GAMES_COUNT = 3;

export const DEFAULT_SLIDE_GRID: SlideGrid = {
  desktopL: { cols: 4 },
  desktop: { cols: 4 },
  tablet: { cols: 4 },
  mobile: { cols: 4 },
  mobileS: { cols: 3 },
};
